import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { Form, Col, Row, Card, Tag, Spin, Button, Table, Input, message, Select } from "antd"
import { API, Auth, Storage } from "aws-amplify";
import { connect } from "react-redux";
import { allState as mapStateToProps, allDispatch as mapDispatchToProps } from "../../Redux/Selectors";
import { CustomSpinner } from "../../Components/Spin/CustomSpiner"

const { Option } = Select;

const StatesCandidate = [
    {value: 'COMPLETED', name: 'Completo'},
    {value: 'REJECTED', name: 'Rechazado'},
    {value: 'PENDING', name: 'Pendiente'},
    {value: 'APPROVED', name: 'Aprobado'},
    {value: 'PROCESSING', name: 'Procesando'},
    {value: 'CREATED', name: 'Creado'},
    {value: 'VALIDATED', name: 'Validado'},
    {value: 'NOT_VALIDATED', name: 'No Validado'},
]

const VehiclesList = [
    {value: 'MOTORCYCLE', name: 'MOTOCICLETA'},
    {value: 'BIKE', name: 'BICICLETA'},
    {value: 'WALK', name: 'CAMINA'},
    {value: 'CAR', name: 'AUTOMOVIL'},
    {value: 'OTHER', name: 'OTHER'},
]

const documentMapping = {
    licenciadeconductor: {key: 'licenciadeconductor', label: 'Licencia de Conductor'},
    certificadodeantecedentes: {key: 'certificadodeantecedentes', label: 'Certificado de Antecendentes'},
    cedula: {key: 'cedula', label: 'Cédula'},
    hojadevidadelconductor: {key: 'hojadevidadelconductor', label: 'Hoja de Vida'},
    permisodecirculacion: {key: 'permisodecirculacion', label: 'Permiso de Circulación'},
}

class CandidateForm extends Component {

    constructor(props) {
        super(props)
        this.state = {
            candidate: {
                candidate_id: null,
                candidate_number_doc: '',
                last_name: '',
                name: '',
                state_candidate: 'CREATED',
                email: '',
                vehicle_type: 'MOTOCICLETA',
                company: ''
            },
            loading: true,
            statesCandidate: [],
            vehiclesList: [],
            companiesList: []
        }
    }

    componentDidMount() {
        this.getCandidate()
        this.setStatesCandidate()
        this.setVehycleOptions()
        this.getCompanies()
    }

    setVehycleOptions(){
        this.setState({vehiclesList: VehiclesList})
    }

    setStatesCandidate() {
        this.setState({statesCandidate: StatesCandidate})
    }

    getCandidate = () => {
        if (this.props.candidate) {
            Promise.all([
                Auth.currentSession(),
                Auth.currentUserInfo()
            ]).then(([response, user]) => {
                API.get(
                    'test',
                    '/cd/cdcandidate/'+this.props.candidate.candidate_id,
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        }
                    }
                )
                .then(response => {
                    this.setState({candidate: response})
                })
                .catch(err => console.log(err))
            });
        }
        this.setState({loading: false});
    }

    getCompanies = () => {
        this.setState({loading: true})
        Promise.all([
            Auth.currentSession(),
            Auth.currentUserInfo()
        ]).then(([response, user]) => {
            API.get(
                'test',
                '/cd/cdcompany/',
                {
                    headers: {
                        Authorization: response.getIdToken().getJwtToken()
                    }
                }
            )
            .then(response => {
                this.setState({companiesList: response, loading: false})
            })
            .catch(err => console.log(err))
        });
    }

    updateData(field, value) {
        const data = this.state.candidate
        data[field] = value
        this.setState({candidate: data}, () => {
            console.log(this.state)
        })
    }

    save = () => {
        this.props.form.validateFields( { first: true }, (err, values) => {
            if (!err) {
                this.setState({ candidate: this.state.candidate }, () => {
                    this.send_data()
                })
            }
        })
    }

    send_data = () => {
        this.setState({ loading: true })
        Auth.currentSession()
        .then(session => {
            const body = {...this.state.candidate}
            API.post(
                'test',
                '/cd/cdcandidate/',
                {
                    headers: {
                        Authorization: session.getIdToken().getJwtToken()
                    },
                    body: body
                }
            )
            .then(response => {
                message.success("Candidato actualizado")
                this.setState({ loading: false })
            })
            .catch(err => {
                message.error("Error al actualizar Candidato")
                this.setState({ loading: false })
            })
        })
        .catch(err => {
            message.error("Error obteniendo credenciales de usuario")
            console.log(err)
        })
    }

    render() {
        const {getFieldDecorator} = this.props.form;

        if (this.state.loading) {
            return (
                <>
                    <Row type="flex" justify="space-around" align="middle" style={{marginTop: '150px'}}>
                        <Col style={{minHeight: '360px'}}>
                            <Spin indicator={CustomSpinner}/>
                        </Col>
                    </Row>
                </>
            )
        } else {
            return (
                <Card
                    title="Candidato">
                        <div style={{height: '380px', type:'block', width:'95%'}}>
                            <Form>
                                <Col>
                                    <Form.Item label="Nro. Documento">
                                    {
                                        getFieldDecorator('candidate_number_doc', {
                                            rules: [{
                                                required: true,
                                                message: 'Nro. Documento es requerido'
                                            }],
                                            initialValue: this.state.candidate.candidate_number_doc,
                                            value: this.state.candidate.candidate_number_doc
                                        })(
                                            <Input
                                                value={this.state.candidate.candidate_number_doc}
                                                onChange={(e) => this.updateData("candidate_number_doc", e.target.value ? e.target.value : null)}
                                            />
                                        )
                                    }
                                    </Form.Item>
                                </Col>
                                <Row gutter={12} type="flex">
                                    <Col lg={12} xs={24}>
                                        <Form.Item label="Apellido">
                                        {
                                            getFieldDecorator('last_name', {
                                                /*rules: [{
                                                    required: true,
                                                    message: 'Apellido es requerido'
                                                }],*/
                                                initialValue: this.state.candidate.last_name,
                                                value: this.state.candidate.last_name
                                            })(
                                                <Input
                                                    value={this.state.candidate.last_name}
                                                    onChange={(e) => this.updateData("last_name", e.target.value ? e.target.value : null)}
                                                />
                                            )
                                        }
                                        </Form.Item>
                                    </Col>
                                    <Col lg={12} xs={24}>
                                        <Form.Item label="Nombre">
                                        {
                                            getFieldDecorator('name', {
                                                /*  rules: [{
                                                    required: true,
                                                    message: 'Nombre es requerido'
                                                }],*/
                                                initialValue: this.state.candidate.name,
                                                value: this.state.candidate.name
                                            })(
                                                <Input
                                                    value={this.state.candidate.name}
                                                    onChange={(e) => this.updateData("name", e.target.value ? e.target.value : null)}
                                                />
                                            )
                                        }
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={12} type="flex">
                                    <Col lg={8} xs={24}>
                                        <Form.Item label="Estado">
                                        {
                                            getFieldDecorator('state_candidate', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Selecciona el Estado'
                                                }],
                                                initialValue: this.state.candidate.state_candidate,
                                                value: this.state.candidate.state_candidate,
                                            })(
                                                <Select style={{ width: '100%' }}
                                                    placeholder="Estado"
                                                    onChange={(value) => this.updateData("state_candidate", value)}>
                                                    {
                                                        this.state.statesCandidate.map(value => {
                                                            return (<Option key={value.value}
                                                                value={value.value}>{value.name}</Option>)
                                                        })
                                                    }
                                                </Select>
                                            )
                                        }
                                        </Form.Item>
                                    </Col>

                                    <Col lg={8} xs={24}>
                                        <Form.Item label="Vehículo">
                                        {
                                            getFieldDecorator('vehicle_type', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Vehículo es requerido'
                                                }],
                                                initialValue: this.state.candidate.vehicle_type,
                                                value: this.state.candidate.vehicle_type,
                                            })(
                                                <Select style={{ width: '100%' }}
                                                    placeholder="Tipo Vehículo"
                                                    disabled={this.props.operation!=='CREATE'}
                                                    onChange={(value) => this.updateData("vehicle_type", value)}>
                                                    {
                                                        this.state.vehiclesList.map(value => {
                                                            return (<Option key={value.value}
                                                                value={value.value}>{value.name}</Option>)
                                                        })
                                                    }
                                                </Select>
                                            )
                                        }
                                        </Form.Item>
                                    </Col>
                                    <Col lg={8} xs={24}>
                                        <Form.Item label="Empresa">
                                        {
                                            getFieldDecorator('company_id', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Empresa es requerido'
                                                }],
                                                initialValue: this.state.candidate.company_id,
                                                value: this.state.candidate.company_id,
                                            })(
                                                <Select style={{ width: '100%' }}
                                                    placeholder="Empresa"
                                                    disabled={this.props.operation!=='CREATE'}
                                                    onChange={(value) => this.updateData("company_id", value)}>
                                                    {
                                                        this.state.companiesList.map(value => {
                                                            console.log("valor "+ value)
                                                            return (<Option key={value.company_id}
                                                                value={value.company_id}>{value.name}</Option>)
                                                        })
                                                    }
                                                </Select>
                                            )
                                        }
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={12} type="flex">
                                    <Col lg={12} xs={24}>
                                        <Form.Item label="Teléfono">
                                        {
                                            getFieldDecorator("candidate_phone", {
                                                initialValue: this.state.candidate.candidate_phone,
                                                value: this.state.candidate.candidate_phone,
                                                rules: [{
                                                    required: true,
                                                    message: 'Teléfono es requerido'
                                                }],
                                            })(
                                                <Input
                                                    value={this.state.candidate.candidate_phone}
                                                    onChange={(e) => this.updateData("candidate_phone", e.target.value ? e.target.value : null)}
                                                />
                                            )
                                        }
                                        </Form.Item>
                                    </Col>
                                    <Col lg={12} xs={24}>
                                        <Form.Item label="Email">
                                        {
                                            getFieldDecorator("email", {
                                                initialValue: this.state.candidate.email,
                                                value: this.state.candidate.email,
                                                rules: [
                                                    {
                                                        type: 'email',
                                                        message: 'Email inválido',
                                                    },
                                                ]
                                            })(
                                                <Input
                                                    value={this.state.candidate.email}
                                                    onChange={(e) => this.updateData("email", e.target.value ? e.target.value : null)}
                                                />
                                            )
                                        }
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                            <Row gutter={8} type="flex">
                                <Col>
                                    <Button
                                        type="primary"
                                        onClick={this.save}>
                                            Guardar
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                </Card>
            )
        }
    }
}

const CandidateFormComponent = Form.create({ name: 'candidateForm' })(CandidateForm);
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CandidateFormComponent));